<script setup lang="ts">
/** "… schreibt gerade"-Indikator mit den drei hüpfenden Punkten. */
defineProps<{ name: string }>()
</script>

<template>
  <div class="dc-typing">
    <span class="dc-typing-dots" aria-hidden="true">
      <i /><i /><i />
    </span>
    <span><strong>{{ name }}</strong> is typing…</span>
  </div>
</template>

<style scoped>
.dc-typing {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-discord);
  font-size: 0.8rem;
  color: var(--dc-ink);
  padding: 4px 16px 6px;
}

.dc-typing strong {
  font-weight: 600;
}

.dc-typing-dots {
  display: inline-flex;
  gap: 3px;
}

.dc-typing-dots i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--dc-ink-muted);
  animation: dc-bounce 1.2s ease-in-out infinite;
}

.dc-typing-dots i:nth-child(2) {
  animation-delay: 0.15s;
}

.dc-typing-dots i:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes dc-bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.55;
  }

  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
</style>
